import React from 'react';
import { motion } from 'framer-motion';
import { secondsInPast } from '../../Utils/time';
import { GAtrack } from '../../Utils/tracking';
import { AppContext } from '../../App';

const Heat = ({ heat, activeHeat, setHeat, delay, category, config }) => {
  const context = React.useContext(AppContext);
  const animationConfig = context.config.animation;
  const itemAnimation = {
    hidden: {
      y: 20,
      opacity: 0,
      transition: {
        duration: animationConfig.duration,
        ease: animationConfig.ease
      }
    },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: animationConfig.duration,
        ease: animationConfig.ease
      }
    }
  };
  return (
    <motion.div
      className="heat"
      onClick={() => {
        const dataLayerArgs = {
          // dataLayer: {
          event: 'rbVideoTracking',
          event_name: 'video_sidebar',
          video_sidebar: {
            value: `${category}::${heat.name}`,
            widget_type: `Knockout Tree - ${
              config.trackingTitle || config.navigationTitle
            }`
          }
          // eventCategory: 'video',
          // eventAction: 'sidebar'
          // }
        };

        GAtrack(dataLayerArgs);

        setHeat(heat);
      }}
    >
      <motion.span
        variants={itemAnimation}
        className={`heat-bubble${
          heat.resultIsOfficial &&
          secondsInPast(new Date(heat.resultIsOfficialTimestamp), delay || 60)
            ? ' finished'
            : ''
        }${activeHeat && heat.id === activeHeat.id ? ' active' : ''}`}
      >
        {heat.heatNr}
      </motion.span>
    </motion.div>
  );
};

export { Heat };
